<!-- 答案图片容器 -->
<template>
  <div
    class="answer-image-container"
    :style="{
      ...boxStyle
    }"
  >
    <div :class="['image-container', { overflow: parseInt($attrs.width) > 100 }]">
      <van-image fit="contain" v-bind="{ ...$attrs, ...vanImageAttrs }" />
    </div>
    <div class="tips" v-if="parseInt($attrs.width) > 100">《 左右滑动查看完整流程 》</div>
  </div>
</template>
<script>
export default {
  name: 'AnswerImageContainer',
  props: {
    boxWidth: {
      type: String,
      default: '200px'
    },
    boxHeight: {
      type: String,
      default: '300px'
    }
  },
  data() {
    return {
      boxStyle: {},
      vanImageAttrs: {}
    }
  },
  mounted() {
    if (parseInt(this.$attrs.width) > 100) {
      this.boxStyle = {
        width: '100%',
        height: 'max-content'
      }
      this.vanImageAttrs = {
        width: this.$attrs.width,
        height: 'auto'
      }
    } else {
      this.boxStyle = {
        width: '60%',
        height: 'max-content'
      }
      this.vanImageAttrs = {
        width: '100%',
        height: 'auto'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.answer-image-container {
  overflow: hidden;
  margin: 0 auto;
  position: relative;
  & + .answer-image-container {
    margin-top: 20px;
  }
  .image-container {
    width: 100%;
    height: 100%;
    overflow-x: auto;
    overflow-y: hidden;

    &.overflow {
      height: calc(100% - 20px);
    }
  }
  .tips {
    height: 20px;
    width: 100%;
    text-align: center;
    font-size: 12px;
    line-height: 20px;
    color: #c40e18;
  }
}
</style>
